import React, {  } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import Card from '../../../components/Card';
import { distances } from '../../../styles/constants';
import { P } from '../../../components/Typography';
import { NextButton } from './';

interface SaveEditProps {
    title: string;
}

const SaveEdit = (
    {
        title,
    }: SaveEditProps
) => {
    const { t } = useTranslation();

    return (
        <Card
            title={title}
            shortHr
            marginBottom={distances.tiny}
        >
            <TextWrapper>
                <P>{t('marketing.campaign.check_if_ok')}</P>
            </TextWrapper>
            <NextButton type="submit">{t('marketing.campaign.save')}</NextButton>
        </Card>
    );
};

const TextWrapper = styled.div`
    margin: ${distances.normal} 0;
`;

export default SaveEdit;
